
// ============================================
// CookiePolicyScene - クッキーポリシーページシーン
// ============================================

/**
 * GNS.CookiePolicyScene
 * 
 * クッキーポリシーページの処理
 * シンプルな静的ページ
 */
GNS.CookiePolicyScene = function (GNS) {
    var b = GNS.create(GNS.AbstractScene);
    return b.init = function (data) {
        b._super.init.apply(this, [data])
    }, b.showHandler = function () { }, b.hideHandler = function () { }, b.resetHandler = function () { }, b._self
}(GNS);
